module.exports = __webpack_public_path__ + "media/images/DoorTop-400cf98bd6a2ec1b88233cab9665326c.png";